import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    offset: { type: Number, default: 0 },
  }

  connect() {
    this.resizeSelect()
  }

  // Dynamically resize the select to match the selected option (instead of the longest option)
  resizeSelect() {
    if (this.element.tagName !== 'SELECT') return

    const selectElement = this.element
    const tempSpan = document.createElement('span')
    tempSpan.style.visibility = 'hidden'
    tempSpan.style.position = 'absolute'
    tempSpan.style.whiteSpace = 'nowrap'
    tempSpan.innerText = selectElement.options[selectElement.selectedIndex].text
    document.body.appendChild(tempSpan)

    const computedStyle = window.getComputedStyle(selectElement)
    const padding =
      parseFloat(computedStyle.paddingLeft) +
      parseFloat(computedStyle.paddingRight)

    const newWidth = tempSpan.offsetWidth + this.offsetValue + padding + 2 // Add some padding
    selectElement.style.width = newWidth + 'px'

    document.body.removeChild(tempSpan)
  }
}
